import { defineMessages } from 'react-intl';

export default defineMessages({
  notFound: {
    id: 'Oops! Error 404',
    defaultMessage: 'Oops! Error 404',
  },
  notFoundTitle: {
    id: '404 - Page not found',
    defaultMessage: '404 - Page not found',
  },
  notFoundDesc: {
    id: 'We did not find what you were looking for. Please try again or return to the beginning.',
    defaultMessage: 'We did not find what you were looking for. Please try again or return to the beginning.',
  },
  homeBtn: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  interestingArticles: {
    id: 'Maybe you\'re interested in',
    defaultMessage: 'Maybe you\'re interested in'
  },
  serverError: {
    id: 'Oops! Error {statusCode}',
    defaultMessage: 'Oops! Error {statusCode}',
  },
  serverErrorTitle: {
    id: '{statusCode} - Server error',
    defaultMessage: '{statusCode} - Server error',
  },
  serverErrorDesc: {
    id: 'Something has gone wrong, sorry for the inconvenience.',
    defaultMessage: 'Something has gone wrong, sorry for the inconvenience.',
  },
  serverErrorTextOne: {
    id: 'Please try again in a few moments',
    defaultMessage: 'Please try again in a few moments',
  },
  serverErrorTextConjunction: {
    id: 'o',
    defaultMessage: 'o',
  },
  serverErrorTextTwo: {
    id: 'Continue browsing using the menu',
    defaultMessage: 'Continue browsing using the menu',
  },
  refreshBtn: {
    id: 'Refresh Screen',
    defaultMessage: 'Refresh Screen',
  }
});
